import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "href", "className", "type", "label", "leftIcon", "rightIcon"],
  _excluded2 = ["component"],
  _excluded3 = ["component"],
  _excluded4 = ["htmlProps"],
  _excluded5 = ["htmlProps"],
  _excluded6 = ["htmlProps"],
  _excluded7 = ["htmlProps"];
import { forwardRef, Fragment } from 'react';
import cn from 'classnames';
import getDefaultIconPropValues from "../../helpers/getDefaultIconPropValues";
import parseClassnames from "../../helpers/parseClassnames";
import { TAGS } from "../classnames";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TextTag = function TextTag(_ref, ref) {
  var as = _ref.as,
    href = _ref.href,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    label = _ref.label,
    leftIconProp = _ref.leftIcon,
    rightIconProp = _ref.rightIcon,
    textTagProps = _objectWithoutProperties(_ref, _excluded);
  var _getDefaultIconPropVa = getDefaultIconPropValues(leftIconProp, 16),
    LeftIcon = _getDefaultIconPropVa.component,
    leftIcon = _objectWithoutProperties(_getDefaultIconPropVa, _excluded2);
  var _getDefaultIconPropVa2 = getDefaultIconPropValues(rightIconProp, 16),
    RightIcon = _getDefaultIconPropVa2.component,
    rightIcon = _objectWithoutProperties(_getDefaultIconPropVa2, _excluded3);
  var wrapperClassName = parseClassnames(className, cn(TAGS.text[type], href || textTagProps.onClick ? 'cursor-pointer' : 'cursor-default'));
  var renderChildren = function renderChildren() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [LeftIcon && /*#__PURE__*/_jsx(LeftIcon, {
        size: leftIcon.size,
        className: cn('mr-4', {
          'fill-current': leftIcon.hasFill,
          'stroke-current': leftIcon.hasStroke
        }),
        ignoreColor: true
      }), label, RightIcon && /*#__PURE__*/_jsx(RightIcon, {
        size: rightIcon.size,
        className: cn('ml-4', {
          'fill-current': rightIcon.hasFill,
          'stroke-current': rightIcon.hasStroke
        }),
        ignoreColor: true
      })]
    });
  };
  if (as === 'a' || href) {
    var _ref2 = textTagProps,
      _htmlProps = _ref2.htmlProps,
      aProps = _objectWithoutProperties(_ref2, _excluded4);
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      href: href,
      className: wrapperClassName
    }, _htmlProps), aProps), {}, {
      children: renderChildren()
    }));
  }
  if (as === 'button' || textTagProps.onClick) {
    var _ref3 = textTagProps,
      _htmlProps2 = _ref3.htmlProps,
      buttonProps = _objectWithoutProperties(_ref3, _excluded5);
    return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      type: "button",
      className: wrapperClassName
    }, _htmlProps2), buttonProps), {}, {
      children: renderChildren()
    }));
  }
  if (as === 'label') {
    var _ref4 = textTagProps,
      _htmlProps3 = _ref4.htmlProps,
      labelProps = _objectWithoutProperties(_ref4, _excluded6);
    return /*#__PURE__*/_jsx("label", _objectSpread(_objectSpread(_objectSpread({
      ref: ref,
      className: wrapperClassName
    }, _htmlProps3), labelProps), {}, {
      children: renderChildren()
    }));
  }
  var _ref5 = textTagProps,
    htmlProps = _ref5.htmlProps,
    spanProps = _objectWithoutProperties(_ref5, _excluded7);
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: wrapperClassName
  }, htmlProps), spanProps), {}, {
    children: renderChildren()
  }));
};
export default /*#__PURE__*/forwardRef(TextTag);